import {
    type FC
} from "react";
import {
    TouchableOpacity,
    View
} from "react-native";
import type IRowCardProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../core/hooks";
import Text from "../text";

const RowCard: FC<IRowCardProps> = ({
    rightSubTitleVariant = "labelLargeSize",
    rightTitleVariant = "labelLargeSize",
    subTitleVariant = "labelLargeSize",
    titleVariant = "labelLargeSize",
    rightContentContainerStyle,
    rightIcon: CustomRightIcon,
    leftContentContainerStyle,
    isTransparentBackground,
    type = "first-based",
    rightContainerStyle,
    leftContainerStyle,
    rightSubTitleColor,
    rightSubTitleStyle,
    leftSubTitleStyle,
    icon: CustomIcon,
    backgroundColor,
    rightTitleColor,
    rightTitleStyle,
    leftTitleStyle,
    rightIconStyle,
    rightSubTitle,
    subTitleColor,
    customTheme,
    rightTitle,
    titleColor,
    iconColor,
    iconStyle,
    iconSize,
    subTitle,
    onPress,
    style,
    title
}) => {
    const {
        radiuses,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        rightIconContainer: rightIconContainerDynamicStyle,
        rightContainer: rightContainerDynamicStyle,
        iconContainer: iconContainerDynamicStyle,
        leftContainer: leftContainerDynamicStyle,
        rightSubTitle: rightSubTitleDynamicStyle,
        rightTitle: rightTitleDynamicStyle,
        container: containerDynamicStyle,
        subTitle: subTitleDynamicStyle,
        title: titleDynamicStyle
    } = useStyles({
        isTransparentBackground,
        backgroundColor,
        radiuses,
        subTitle,
        spaces,
        colors,
        type
    });

    const renderRightIcon = () => {
        if(!CustomRightIcon) {
            return null;
        }

        return <View
            style={[
                rightIconStyle,
                stylesheet.rightIconContainer,
                rightIconContainerDynamicStyle
            ]}
        >
            <CustomRightIcon
                color="default"
                size={18}
            />
        </View>;
    };

    const renderLeftIcon = () => {
        if(!CustomIcon) {
            return null;
        }

        return <View
            style={[
                iconStyle,
                stylesheet.iconContainer,
                iconContainerDynamicStyle
            ]}
        >
            <CustomIcon
                color={iconColor ? iconColor : "default"}
                size={iconSize ? iconSize : 18}
            />
        </View>;
    };

    const renderLeftSubTitle = () => {
        if(!subTitle) {
            return null;
        }

        return <Text
            color={subTitleColor ? subTitleColor : "low"}
            variant={subTitleVariant}
            style={[
                leftSubTitleStyle,
                stylesheet.subTitle,
                subTitleDynamicStyle
            ]}
        >
            {subTitle}
        </Text>;
    };

    const renderLeftContent = () => {
        return <View
            style={[
                leftContentContainerStyle
            ]}
        >
            <Text
                variant={titleVariant}
                style={[
                    leftTitleStyle,
                    stylesheet.title,
                    titleDynamicStyle
                ]}
                color={titleColor}
            >
                {title}
            </Text>
            {renderLeftSubTitle()}
        </View>;
    };

    const renderLeft = () => {
        return <View
            style={[
                leftContainerStyle,
                stylesheet.leftContainer,
                leftContainerDynamicStyle
            ]}
        >
            {renderLeftContent()}
        </View>;
    };

    const renderRightSubTitle = () => {
        if(!rightSubTitle) {
            return null;
        }

        return <Text
            color={rightSubTitleColor? rightSubTitleColor : "low"}
            variant={rightSubTitleVariant}
            style={[
                rightSubTitleStyle,
                stylesheet.rightSubTitle,
                rightSubTitleDynamicStyle
            ]}
        >
            {rightSubTitle}
        </Text>;
    };

    const renderRightContent = () => {
        return <View
            style={[
                rightContentContainerStyle
            ]}
        >
            <Text
                variant={rightTitleVariant}
                style={[
                    rightTitleStyle,
                    stylesheet.rightTitle,
                    rightTitleDynamicStyle
                ]}
                color={rightTitleColor}
            >
                {rightTitle}
            </Text>
            {renderRightSubTitle()}
        </View>;
    };

    const renderRight = () => {
        return <View
            style={[
                rightContainerStyle,
                stylesheet.rightContainer,
                rightContainerDynamicStyle
            ]}
        >
            {renderRightContent()}
        </View>;
    };

    return <TouchableOpacity
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        onPress={() => {
            if(onPress) {
                onPress();
            }
        }}
    >
        {renderLeftIcon()}
        {renderLeft()}
        {renderRight()}
        {renderRightIcon()}
    </TouchableOpacity>;
};
export default RowCard;
